// extracted by mini-css-extract-plugin
export var active = "Sidebar-module--active--i+o3N";
export var arrowIcon = "Sidebar-module--arrow-icon--sWNCw";
export var arrowIconCircle = "Sidebar-module--arrow-icon-circle--n-bvw";
export var arrowIconFill = "Sidebar-module--arrow-icon-fill--JWiKA";
export var navOpen = "Sidebar-module--nav-open--Ro9EN";
export var offerRoomSidebar = "Sidebar-module--offer-room-sidebar--67wYc";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var sticky = "Sidebar-module--sticky--rqu2b";